'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectivePath$$anon$64(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectivePath$$anon$64 as $c_Lpresto_types$DirectivePath$$anon$64 };
$p = $c_Lpresto_types$DirectivePath$$anon$64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectivePath$$anon$64;
/** @constructor */
function $h_Lpresto_types$DirectivePath$$anon$64() {
}
export { $h_Lpresto_types$DirectivePath$$anon$64 as $h_Lpresto_types$DirectivePath$$anon$64 };
$h_Lpresto_types$DirectivePath$$anon$64.prototype = $p;
$p.bn = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  $j_presto$002etypes$0024.$m_Lpresto_types$();
  if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(text) === "")) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "value is empty"));
  } else {
    try {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text);
    } catch (e) {
      var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
      if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
      } else {
        throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
      }
    }
  }
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$DirectivePath$$anon$64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectivePath$$anon$64, "presto.types$DirectivePath$$anon$64", ({
  ZD: 1,
  K: 1
}));
export { $d_Lpresto_types$DirectivePath$$anon$64 as $d_Lpresto_types$DirectivePath$$anon$64 };
//# sourceMappingURL=presto.types$-Directive-Path$$anon$64.js.map
